<template>
  <div class="text-center">
    <img alt="not-found" width="800" height="600" src="@/core/assets/404.svg" />
    <p class="lead font-size-2 mb-0">{{ $t("error404.urlNotFound") }}</p>
    <hr class="my-4" />
    <b-button variant="primary" class="my-2 my-sm-0" type="button" @click="handleClick"
      >{{ $t("error404.home") }}
    </b-button>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "404",
  setup() {
    const router = useRouter();
    return {
      router
    };
  },
  methods: {
    handleClick() {
      this.router.push({ name: "LandingPage" });
    }
  }
});
</script>
